import {
  Droplet,
  Droplets,
  Fish,
  Leaf,
  CircleDot,
  Package,
  FlaskConical,
  Egg,
  Snowflake,
  Sparkles,
  ShoppingBag,
} from "lucide-react";

const ICONS = {
  Droplet,
  Droplets,
  Fish,
  Leaf,
  CircleDot,
  Package,
  FlaskConical,
  Egg,
  Snowflake,
  Sparkles,
};

export default function ProductIcon({ name, className = "", strokeWidth = 1.25 }) {
  const Icon = ICONS[name] || ShoppingBag;
  return <Icon className={className} strokeWidth={strokeWidth} aria-hidden />;
}
